/** `.workout-detail-panel` backdrop + panel use 1500 / 1501. */
export const WORKOUT_DETAIL_SHEET_Z = 1600;

/** Nested sheet (e.g. date picker opened from a sheet inside workout detail). */
export const WORKOUT_DETAIL_NESTED_SHEET_Z = 1700;

/** AI prompt sheet — must sit above `.wf-form` (3000) and setup modal (14000). */
export const WORKOUT_AI_PROMPT_SHEET_Z = 14500;
